import { Button, Container } from "@mui/material";


import "./sign-out-style.scss"
import { signOut } from "../../../app/services/http-services/request-backend-api";

const SignOutComponent = () => {

    return (
        <>
            <Container >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={signOut}
                >
                    Sign out
                </Button>
            </Container>
        </>
    )
}

export default SignOutComponent;